import { Switch } from "@shapr3d/frontend-lib";
import classNames from "classnames";
import { useController } from "react-hook-form";

import { useTracker } from "../../../../hooks/useTracker";
import useTranslation from "../../../../hooks/useTranslation";
import { ElementClickAction } from "../../../../lib/TrackingAdapter";
import { useCheckoutFormContext } from "../CheckoutFormProvider";

import style from "./MigrationConsent.module.css";

const name = "migrationConsent";

export default function MigrationConsent() {
  const { t, m } = useTranslation();
  const {
    methods: {
      control,
      clearErrors,
      formState: { errors },
    },
  } = useCheckoutFormContext();

  const { field } = useController({
    name,
    control,
  });

  const tracker = useTracker();

  const checkedError = errors[name]?.message;

  return (
    <div>
      <div className={classNames(style.consentContainer)}>
        <Switch
          checked={field.value}
          onChange={() => {
            const value = !field.value;
            field.onChange(value);
            clearErrors(name);

            tracker.trackButtonClick({
              action: ElementClickAction.APP_STORE_CHARGEBEE_TERMS_TOGGLE,
              details: value ? "on" : "off",
            });
          }}
        />
        <div className={style.consent}>{t(m.Checkout.MigrationConsent.Text)}</div>
      </div>
      {Boolean(checkedError) && <span className={style.consentErrorMessage}>{checkedError}</span>}
    </div>
  );
}
